import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, Spinner, Text } from '@chakra-ui/react';
import { useAuth } from 'contexts/AuthContext';
import routes from 'routes';
import { canAccessRoute, firstAllowedAdminPath } from 'constants/permissions';
import { findAdminRoute } from 'utils/adminRoutes';

export default function RequirePermission({ children }) {
  const { user, isLoading } = useAuth();
  const location = useLocation();
  const matchedRoute = findAdminRoute(routes, location.pathname);

  if (isLoading) {
    return (
      <Box py={20} textAlign="center">
        <Spinner size="lg" />
      </Box>
    );
  }

  if (!matchedRoute || canAccessRoute(user, matchedRoute)) {
    return children;
  }

  const fallback = firstAllowedAdminPath(user, routes);
  if (location.pathname !== fallback) {
    return <Navigate to={fallback} replace />;
  }
  return (
    <Box py={20} textAlign="center">
      <Text>Нет доступа к этому разделу</Text>
    </Box>
  );
}
